import EventBus from '@/shared/eventBus'
import { CLOSE_CLOUDFLARE_CHALLENGE, SHOW_CLOUDFLARE_CHALLENGE } from '@/shared/eventContract'

export function checkCloudflareChallenge(response) {
  return response?.headers?.['cf-mitigated'] === 'challenge'
}

async function waitForChallengeToPass() {
  return new Promise((resolve) => {
    function handleMessage(event) {
      if (event.data.type === 'gate-passed') {
        window.removeEventListener('message', handleMessage)
        resolve(true)
      }
    }

    window.addEventListener('message', handleMessage)
  })
}

export async function handleCloudflareChallenge(config) {
  EventBus.emit(SHOW_CLOUDFLARE_CHALLENGE)

  const passed = await waitForChallengeToPass()

  if (!passed) throw config

  EventBus.emit(CLOSE_CLOUDFLARE_CHALLENGE)

  return config
}
